module.exports = new __parcel__URL__("chrome-icon.875ad4bc.svg").toString();